module.exports = __webpack_public_path__ + "img/logo_desk.c1ef5dd.png";